import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'

import { white } from 'styles/colors'
import { header1, title } from 'styles/texts'
import { saveConsultant, unsaveConsultant, approveConsultant } from 'actions'
import {
  consultantSelector,
  consultantTitlesSelector,
  isSelfSelector,
  hasChatSelector,
  chatIdSelector,
  updateUserInfoPendingSelector,
  isAdminSelector,
  isConsultantListedSelector,
} from 'selectors'

import AvailabilityComponent from 'components/Availability'
import ProfilePicture from 'components/ProfilePicture'
import ButtonComponent from 'components/Button'
import Highlighted from 'components/Highlighted'
import EditModalButton from 'components/EditModalButton'
import EditUserInfo from 'components/EditUserInfo'
import ContactModalButton from 'components/ContactModalButton'
import LogoComponent from 'components/Logo'

const Wrapper = styled.div`
  padding: 30px;
  background-color: ${white};
  border-radius: 6px;
`

const Top = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`

const Name = styled.div`
  ${header1};
  margin-top: 20px;
  display: flex;
`

const Titles = styled(Highlighted)`
  ${title};
`

const Availability = styled(AvailabilityComponent)`
  margin: 10px 0 30px;
`

const Buttons = styled.div`
  display: flex;

  & > *:not(:last-child) {
    margin-right: 10px;
  }
`

const Button = styled(ButtonComponent)`
  flex-grow: 1;
  flex-basis: 1px;
  display: flex;
  width: 110px;
  justify-content: center;
`

const Icon = styled.img`
  margin-right: 3px;
`

const Logo = styled(LogoComponent)`
  width: 96px;
`

const ConsultantInfo = ({
  className,
  consultantId,
  name,
  profilePicture,
  titles,
  employer,
  saveConsultant,
  unsaveConsultant,
  isSaved,
  isSelf,
  isAdmin,
  hasChat,
  chatId,
  loading,
  isListed,
  approveConsultant,
}) => (
  <Wrapper className={className}>
    <Top>
      <ProfilePicture src={profilePicture} size={60} />
      <Logo name={employer} />
    </Top>
    <Name>
      <div>{name}</div>
      {(isSelf || isAdmin) && (
        <EditModalButton
          title="Endre profil"
          loading={loading}
          renderForm={props => (
            <EditUserInfo {...props} consultantId={consultantId} />
          )}
        />
      )}
    </Name>
    <Titles>{titles.join(', ')}</Titles>
    <Availability consultantId={consultantId} />
    {!isSelf && (
      <Buttons>
        <ContactModalButton
          consultantId={consultantId}
          renderButton={({ onClick }) => (
            <Button
              to={hasChat ? `/chat/${chatId}` : undefined}
              onClick={hasChat ? undefined : onClick}>
              <Icon src="/icons/chat-white.svg" alt="" />
              <div>Kontakt denne ungdommen</div>
            </Button>
          )}
        />
        {isAdmin && !isListed ? (
          <Button secondary onClick={() => approveConsultant(consultantId)}>
            <Icon src="/icons/approve-pink.svg" alt="" />
            <div>Godkjenn</div>
          </Button>
        ) : (
          <Button
            secondary
            onClick={() =>
              isSaved
                ? unsaveConsultant(consultantId)
                : saveConsultant(consultantId)
            }
            active={isSaved}>
            <Icon
              src={isSaved ? '/icons/saved.svg' : '/icons/save-blue.svg'}
              alt=""
            />
            <div>{isSaved ? 'Lagret' : 'Lagre'}</div>
          </Button>
        )}
      </Buttons>
    )}
  </Wrapper>
)

const mapStateToProps = (state, { consultantId }) => ({
  ...(consultantSelector(state, consultantId) || {}),
  titles: consultantTitlesSelector(state, consultantId) || [],
  isSelf: isSelfSelector(state, consultantId),
  hasChat: hasChatSelector(state, consultantId),
  chatId: chatIdSelector(state, consultantId),
  loading: updateUserInfoPendingSelector(state),
  isAdmin: isAdminSelector(state),
  isListed: isConsultantListedSelector(state, consultantId),
})

const mapDispatchToProps = {
  saveConsultant,
  unsaveConsultant,
  approveConsultant,
}

export default connect(mapStateToProps, mapDispatchToProps)(ConsultantInfo)



// WEBPACK FOOTER //
// ./src/components/Consultant/ConsultantInfo.js